import URL from '../api_url';

export const USER_API = `${URL}/user`;

export const USERS_API = `${URL}/users`;